(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[858],{

/***/ 75137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_AlertModal; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Modal/index.tsx
var Modal = __webpack_require__(46807);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/TouchableOpacity/index.js
var TouchableOpacity = __webpack_require__(28908);
var TouchableOpacity_default = /*#__PURE__*/__webpack_require__.n(TouchableOpacity);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/View/index.js
var View = __webpack_require__(79057);
var View_default = /*#__PURE__*/__webpack_require__.n(View);
// EXTERNAL MODULE: ./src/constants/index.ts + 6 modules
var constants = __webpack_require__(22120);
// EXTERNAL MODULE: ./src/components/Layout/index.tsx + 4 modules
var Layout = __webpack_require__(66001);
// EXTERNAL MODULE: ./src/components/HorizontalSeparator/index.tsx
var HorizontalSeparator = __webpack_require__(91957);
// EXTERNAL MODULE: ./src/components/Text/index.tsx
var Text = __webpack_require__(71605);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/VerticalSeparator/index.tsx






var VerticalSeparator = function VerticalSeparator(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
    style: [styles.root, props.style]
  });
};

var styles = StyleSheet_default().create({
  root: {
    width: (StyleSheet_default()).hairlineWidth,
    height: '100%',
    backgroundColor: constants/* NewColor.OnWhiteBorderGray */.Wq.OnWhiteBorderGray
  }
});
/* harmony default export */ var components_VerticalSeparator = (VerticalSeparator);
;// CONCATENATED MODULE: ./src/components/AlertModal/index.tsx














var AlertModal = function AlertModal(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Modal/* Modal */.u, {
    visible: props.visible,
    size: "extra-thin",
    onClose: props.onCancel != null ? props.onCancel : props.onAccept,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Layout/* EdgeGutter */.MX, {
      style: [AlertModal_styles.content, constants/* GridStyle.MT4Unit */.Hy.MT4Unit, constants/* GridStyle.MB2Unit */.Hy.MB2Unit],
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        style: [constants/* TextStyle.T16B */.pn.T16B, constants/* TextStyle.ACenter */.pn.ACenter, constants/* GridStyle.MBUnit */.Hy.MBUnit],
        children: props.title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* EdgeGutter */.MX, {
        style: AlertModal_styles.content,
        children: props.details != null ? /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
          style: [constants/* TextStyle.T12R */.pn.T12R, constants/* TextStyle.ACenter */.pn.ACenter, constants/* GridStyle.MTUnit */.Hy.MTUnit, constants/* GridStyle.MBUnit */.Hy.MBUnit],
          children: props.details
        }) : null
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HorizontalSeparator/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: AlertModal_styles.buttonRow,
      children: [props.onCancel != null ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((TouchableOpacity_default()), {
          onPress: props.onCancel,
          style: AlertModal_styles.button,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
            style: [constants/* TextStyle.T12M */.pn.T12M, constants/* TextStyle.CBolt */.pn.CBolt],
            children: 'Cancel'
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_VerticalSeparator, {})]
      }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)((TouchableOpacity_default()), {
        onPress: props.onAccept,
        style: AlertModal_styles.button,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
          style: [constants/* TextStyle.T12M */.pn.T12M, constants/* TextStyle.CBolt */.pn.CBolt],
          children: 'OK'
        })
      })]
    })]
  });
};

/* harmony default export */ var components_AlertModal = (AlertModal);
var AlertModal_styles = StyleSheet_default().create({
  closeIcon: {
    tintColor: constants/* NewColor.Black */.Wq.Black
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  button: {
    flex: 1,
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    padding: constants/* Grid.dp */.rj.dp(12)
  },
  buttonRow: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  }
});

/***/ }),

/***/ 16291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ WithMemo; },
  "X": function() { return /* reexport */ WithMomentMemo; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Format/WithMemo/index.tsx





function _WithMemo(props) {
  var _React$useState = react.useState(props.formatter != null ? props.formatter(props.value) : ''),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      label = _React$useState2[0],
      setLabel = _React$useState2[1];

  react.useEffect(function () {
    var intervalId;

    if (props.renderInterval != null) {
      intervalId = setInterval(function () {
        // Note (albert): Unsure why, but formatter has the possibility of being undefined sometimes...
        if (props.formatter != null) {
          setLabel(props.formatter(props.value));
        }
      }, props.renderInterval);
    }

    if (props.formatter != null) {
      setLabel(props.formatter(props.value));
    }

    return function () {
      if (intervalId != null) {
        clearInterval(intervalId);
      }
    };
  }, [props.formatter, props.value, props.renderInterval]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: label
  });
}

var WithMemo = /*#__PURE__*/react.memo(_WithMemo);
// EXTERNAL MODULE: ./node_modules/moment-timezone/index.js
var moment_timezone = __webpack_require__(80008);
var moment_timezone_default = /*#__PURE__*/__webpack_require__.n(moment_timezone);
;// CONCATENATED MODULE: ./src/components/Format/WithMomentMemo/index.tsx





function _WithMomentMemo(props) {
  var value = react.useMemo(function () {
    return props.tz != null ? moment_timezone_default()(props.at).tz(props.tz) : moment_timezone_default()(props.at);
  }, [props.at, props.tz]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(WithMemo, {
    value: value,
    formatter: props.formatter,
    renderInterval: props.renderInterval
  });
}

var WithMomentMemo = /*#__PURE__*/react.memo(_WithMomentMemo);
;// CONCATENATED MODULE: ./src/components/Format/index.ts



/***/ }),

/***/ 91957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22120);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84099);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79057);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






var HorizontalSeparator = function HorizontalSeparator(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_3___default()), {
    style: [styles.root, props.style]
  });
};

var styles = react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_4___default().create({
  root: {
    height: (react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_4___default().hairlineWidth),
    backgroundColor: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .NewColor.OnWhiteBorderGray */ .Wq.OnWhiteBorderGray
  }
});
/* harmony default export */ __webpack_exports__["Z"] = (HorizontalSeparator);

/***/ }),

/***/ 13213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ EdgeGutter; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22120);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84099);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28908);
/* harmony import */ var react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79057);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






/**
 * For the horizontal gutters on the edge of the screen.
 */


var EdgeGutter = function EdgeGutter(props) {
  if (props.onPress != null) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_4___default()), _objectSpread(_objectSpread({
      activeOpacity: 0.7
    }, props), {}, {
      style: [styles.root, props.style],
      children: props.children
    }));
  } else {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_5___default()), {
      style: [styles.root, props.style],
      children: props.children
    });
  }
};
var styles = react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_6___default().create({
  root: {
    paddingHorizontal: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .Grid.dp */ .rj.dp(12)
  }
});

/***/ }),

/***/ 8666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ SettingsSwitchRow; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16835);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22120);
/* harmony import */ var _EdgeGutter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13213);
/* harmony import */ var src_components_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71605);
/* harmony import */ var react_native_web_dist_cjs_exports_Switch__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96138);
/* harmony import */ var react_native_web_dist_cjs_exports_Switch__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_Switch__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84099);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79057);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);










var TRACK_COLOR = {
  "false": src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Color.DarkShade */ .Il.DarkShade,
  "true": src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Color.Affirmative */ .Il.Affirmative
};
var SettingsSwitchRow = function SettingsSwitchRow(props) {
  var _Boolean;

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState((_Boolean = Boolean(props.defaultValue)) !== null && _Boolean !== void 0 ? _Boolean : false),
      _React$useState2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_React$useState, 2),
      enabled = _React$useState2[0],
      setEnabled = _React$useState2[1];

  var toggleSwitch = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function () {
    setEnabled(!enabled);

    if (props.onChange != null) {
      props.onChange(!enabled);
    }
  }, [props.onChange, enabled]);
  var trackColor = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function () {
    var trackColorOverride = props.trackColor;

    if (trackColorOverride != null) {
      return {
        "false": src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Color.DarkShade */ .Il.DarkShade,
        "true": trackColorOverride
      };
    } else {
      return TRACK_COLOR;
    }
  }, [props.trackColor]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_EdgeGutter__WEBPACK_IMPORTED_MODULE_2__/* .EdgeGutter */ .M, {
    style: styles.root,
    onPress: props.onPress,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
      style: props.descriptionNode == null ? styles.titleAlone : styles.titleWithDescription,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        style: [src_constants__WEBPACK_IMPORTED_MODULE_1__/* .TextStyle.T16B */ .pn.T16B],
        children: props.titleNode
      }), props.descriptionNode != null ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(src_components_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        style: [styles.description, src_constants__WEBPACK_IMPORTED_MODULE_1__/* .TextStyle.T12R */ .pn.T12R, src_constants__WEBPACK_IMPORTED_MODULE_1__/* .TextStyle.CSecondary */ .pn.CSecondary],
        children: props.descriptionNode
      }) : null]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_Switch__WEBPACK_IMPORTED_MODULE_7___default()), {
      disabled: props.disabled,
      trackColor: trackColor,
      thumbColor: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Color.Inverse */ .Il.Inverse,
      onValueChange: toggleSwitch,
      value: enabled,
      style: styles["switch"]
    })]
  });
};
var styles = react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_8___default().create({
  root: {
    flexDirection: 'row',
    minHeight: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dp */ .rj.dp(50)
  },
  icon: {
    width: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dp */ .rj.dp(30),
    height: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dp */ .rj.dp(30),
    borderRadius: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dp */ .rj.dp(15),
    marginRight: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dp */ .rj.dp(10),
    alignItems: 'center',
    justifyContent: 'center'
  },
  titleAlone: {
    marginTop: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dp */ .rj.dp(12),
    flex: 1
  },
  titleWithDescription: {
    marginTop: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dp */ .rj.dp(6),
    flex: 1
  },
  description: {
    marginBottom: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dp */ .rj.dp(18)
  },
  rightChevronIcon: {
    width: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dp */ .rj.dp(24),
    height: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dp */ .rj.dp(24)
  },
  "switch": {
    marginTop: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dp */ .rj.dp(6),
    transform: [{
      scale: 0.9
    }, {
      translateX: 5
    }]
  }
});

/***/ }),

/***/ 66001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Vz": function() { return /* reexport */ CardGutter; },
  "MX": function() { return /* reexport */ EdgeGutter/* EdgeGutter */.M; },
  "SN": function() { return /* reexport */ SettingsFeatureSwitchRow; },
  "$$": function() { return /* reexport */ SettingsSwitchRow/* SettingsSwitchRow */.$; },
  "wX": function() { return /* reexport */ StatSummary; },
  "wD": function() { return /* reexport */ SummaryRow; }
});

// UNUSED EXPORTS: toggleFeatureStatus

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/constants/index.ts + 6 modules
var constants = __webpack_require__(22120);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/View/index.js
var View = __webpack_require__(79057);
var View_default = /*#__PURE__*/__webpack_require__.n(View);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Layout/CardGutter/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





/**
 * For the horizontal gutters on the edge of the screen.
 */


var CardGutter = function CardGutter(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), _objectSpread(_objectSpread({}, props), {}, {
    style: [styles.root, props.style]
  }));
};
var styles = StyleSheet_default().create({
  root: {
    paddingHorizontal: 2 * constants/* Grid.Unit */.rj.Unit
  }
});
// EXTERNAL MODULE: ./src/components/Layout/EdgeGutter/index.tsx
var EdgeGutter = __webpack_require__(13213);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./src/clients/Network/index.tsx + 10 modules
var Network = __webpack_require__(21324);
// EXTERNAL MODULE: ./src/state/index.ts + 43 modules
var state = __webpack_require__(10468);
// EXTERNAL MODULE: ./src/components/AlertModal/index.tsx + 1 modules
var AlertModal = __webpack_require__(75137);
// EXTERNAL MODULE: ./src/components/Layout/SettingsSwitchRow/index.tsx
var SettingsSwitchRow = __webpack_require__(8666);
;// CONCATENATED MODULE: ./src/components/Layout/SettingsFeatureSwitchRow/index.tsx




function SettingsFeatureSwitchRow_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SettingsFeatureSwitchRow_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SettingsFeatureSwitchRow_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SettingsFeatureSwitchRow_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var toggleFeatureStatus = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(f) {
    var success, res;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            success = false;
            _context.prev = 1;
            _context.next = 4;
            return f();

          case 4:
            res = _context.sent;
            success = res;

            if (!success) {
              _context.next = 9;
              break;
            }

            _context.next = 9;
            return Network/* gql.__deprecated__getPoshmarkUserLinks */.P.__deprecated__getPoshmarkUserLinks({});

          case 9:
            _context.next = 14;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](1);
            console.error(_context.t0);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 11]]);
  }));

  return function toggleFeatureStatus(_x) {
    return _ref.apply(this, arguments);
  };
}();

var SettingsFeatureSwitchRowWithoutData = function SettingsFeatureSwitchRowWithoutData(props) {
  var userLink = react.useContext(state/* Observe.PoshmarkUserLinks.SelectedFallback.Get */.cn.mw.GW.Get);

  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      successAlertVisible = _React$useState2[0],
      setSuccessAlertVisible = _React$useState2[1];

  var _React$useState3 = react.useState(false),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      failedAlertVisible = _React$useState4[0],
      setFailedAlertVisible = _React$useState4[1];

  var _React$useState5 = react.useState(false),
      _React$useState6 = (0,slicedToArray/* default */.Z)(_React$useState5, 2),
      loading = _React$useState6[0],
      setLoading = _React$useState6[1];

  var currentValue = react.useMemo(function () {
    var isEnabled = userLink[props.readFeatureStatus] === 'ENABLED';
    return props.inverted ? !isEnabled : isEnabled;
  }, [userLink, props.readFeatureStatus, props.inverted]);
  var onChange = react.useCallback(function (on) {
    (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (props.disabled) {
                _context2.next = 5;
                break;
              }

              setLoading(true);
              _context2.next = 4;
              return toggleFeatureStatus(function () {
                return Network/* gql.toggleFeatureStatuses */.P.toggleFeatureStatuses((0,defineProperty/* default */.Z)({
                  poshmarkUserLinkId: userLink.id
                }, props.argsFeatureStatus, props.inverted ? !on : on)).then(function (_) {
                  var res = _.superposherToggleFeatureStatuses.success;

                  if (res) {
                    setSuccessAlertVisible(true);
                  } else {
                    setFailedAlertVisible(true);
                  }

                  return res;
                });
              });

            case 4:
              setLoading(false);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }, [userLink.poshmarkUserId, props.argsFeatureStatus, props.inverted, props.disabled]);
  var onSuccessAlertAccept = react.useCallback(function () {
    setSuccessAlertVisible(false);
  }, [setSuccessAlertVisible]);
  var onFailedAlertAccept = react.useCallback(function () {
    setFailedAlertVisible(false);
  }, [setFailedAlertVisible]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SettingsSwitchRow/* SettingsSwitchRow */.$, SettingsFeatureSwitchRow_objectSpread(SettingsFeatureSwitchRow_objectSpread({}, props), {}, {
      defaultValue: currentValue,
      disabled: loading || props.disabled,
      onChange: onChange
    })), /*#__PURE__*/(0,jsx_runtime.jsx)(AlertModal/* default */.Z, {
      onAccept: onSuccessAlertAccept,
      visible: successAlertVisible,
      title: "Saved changes",
      details: "Your change should start taking effect shortly!"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(AlertModal/* default */.Z, {
      onAccept: onFailedAlertAccept,
      visible: failedAlertVisible,
      title: "Unexpected error",
      details: "Failed to save your change. Try again later."
    })]
  });
};

var SettingsFeatureSwitchRow = function SettingsFeatureSwitchRow(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(state/* Observe.PoshmarkUserLinks.SelectedFallback.Provider */.cn.mw.GW.Provider, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(SettingsFeatureSwitchRowWithoutData, SettingsFeatureSwitchRow_objectSpread({}, props))
  });
};
// EXTERNAL MODULE: ./src/components/Text/index.tsx
var Text = __webpack_require__(71605);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/Image/index.js
var Image = __webpack_require__(94965);
var Image_default = /*#__PURE__*/__webpack_require__.n(Image);
;// CONCATENATED MODULE: ./src/components/Layout/SummaryRow/index.tsx









var rightChevronIconSource = {
  uri: '/static/images/app/RightChevronIcon.png'
};
var SummaryRow = function SummaryRow(props) {
  var iconBackgroundStyle = react.useMemo(function () {
    var _props$iconBackground;

    return {
      backgroundColor: (_props$iconBackground = props.iconBackgroundColor) !== null && _props$iconBackground !== void 0 ? _props$iconBackground : constants/* NewColor.Black */.Wq.Black
    };
  }, [props.iconBackgroundColor]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(EdgeGutter/* EdgeGutter */.M, {
    style: [SummaryRow_styles.root, props.style],
    onPress: props.onPress,
    children: [props.iconNode != null ? /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
      style: [iconBackgroundStyle, SummaryRow_styles.icon],
      children: props.iconNode
    }) : null, /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: SummaryRow_styles.title,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        style: [constants/* TextStyle.T16B */.pn.T16B],
        children: props.titleNode
      }), props.descriptionNode != null ? /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        style: [SummaryRow_styles.description, constants/* TextStyle.T12R */.pn.T12R, constants/* TextStyle.CSecondary */.pn.CSecondary],
        children: props.descriptionNode
      }) : null]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        style: [constants/* TextStyle.T16B */.pn.T16B, constants/* TextStyle.ARight */.pn.ARight],
        children: props.valueNode
      })
    }), props.onPress != null ? /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
      style: SummaryRow_styles.iconContainer,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((Image_default()), {
        source: rightChevronIconSource,
        style: SummaryRow_styles.rightChevronIcon
      })
    }) : null]
  });
};
var SummaryRow_styles = StyleSheet_default().create({
  root: {
    flexDirection: 'row',
    height: constants/* Grid.dp */.rj.dp(48),
    alignItems: 'center'
  },
  description: {
    position: 'absolute',
    left: 0,
    top: constants/* Grid.dp */.rj.dp(18)
  },
  iconContainer: {
    transform: [{
      translateX: constants/* Grid.dp */.rj.dp(7)
    }]
  },
  icon: {
    width: constants/* Grid.dp */.rj.dp(30),
    height: constants/* Grid.dp */.rj.dp(30),
    borderRadius: constants/* Grid.dp */.rj.dp(15),
    marginRight: constants/* Grid.dp */.rj.dp(10),
    alignItems: 'center',
    justifyContent: 'center'
  },
  title: {
    flex: 1
  },
  rightChevronIcon: {
    width: constants/* Grid.dp */.rj.dp(24),
    height: constants/* Grid.dp */.rj.dp(24)
  }
});
// EXTERNAL MODULE: ./src/components/Format/index.ts + 2 modules
var Format = __webpack_require__(16291);
// EXTERNAL MODULE: ./src/util/index.ts + 3 modules
var util = __webpack_require__(31660);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/Animated/index.js
var Animated = __webpack_require__(31529);
var Animated_default = /*#__PURE__*/__webpack_require__.n(Animated);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/TouchableOpacity/index.js
var TouchableOpacity = __webpack_require__(28908);
var TouchableOpacity_default = /*#__PURE__*/__webpack_require__.n(TouchableOpacity);
;// CONCATENATED MODULE: ./src/components/Layout/StatSummary/index.tsx













var REFRESH_HIT_SLOP = {
  top: 20,
  left: 20,
  right: 20,
  bottom: 20
};
var refreshIconSource = {
  uri: '/static/images/app/RefreshIcon@3x.png'
};
var StatSummary = function StatSummary(props) {
  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      refreshing = _React$useState2[0],
      setRefreshing = _React$useState2[1];

  var _React$useState3 = react.useState(new (Animated_default()).Value(0)),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 1),
      refreshSpinValue = _React$useState4[0];

  var onRefresh = react.useCallback(function () {
    if (props.onRefresh != null) {
      setRefreshing(true);
      props.onRefresh()["finally"](function () {
        setRefreshing(false);
      });
    }
  }, [props.onRefresh]);
  react.useEffect(function () {
    if (!refreshing) {
      Animated_default().timing(refreshSpinValue, {
        toValue: 0,
        duration: 250,
        useNativeDriver: true
      }).start();
    } else {
      Animated_default().timing(refreshSpinValue, {
        toValue: 1,
        duration: 1500,
        useNativeDriver: true
      }).start();
    }
  }, [refreshing]);
  var dynamicSpinStyle = react.useMemo(function () {
    return {
      transform: [{
        rotate: refreshSpinValue.interpolate({
          inputRange: [0, 1],
          outputRange: ['0deg', '360deg']
        })
      }, {
        scale: refreshSpinValue.interpolate({
          inputRange: [0, 1],
          outputRange: [1, 0.8]
        })
      }]
    };
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(EdgeGutter/* EdgeGutter */.M, {
    style: StatSummary_styles.root,
    children: [props.titleNode != null ? /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: StatSummary_styles.topRow,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        style: [constants/* TextStyle.T12R */.pn.T12R, constants/* TextStyle.CSecondary */.pn.CSecondary],
        children: props.titleNode
      }), props.updatedAt != null ? /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        style: [constants/* TextStyle.T12R */.pn.T12R, constants/* TextStyle.CSecondary */.pn.CSecondary],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Format/* WithMomentMemo */.X, {
          at: props.updatedAt,
          formatter: util.Format.FromNow,
          renderInterval: 5000
        })
      }) : null]
    }) : null, /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: StatSummary_styles.highlightRow,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        style: [constants/* TextStyle.T24B */.pn.T24B, props.highlightNodeTextStyle],
        children: props.highlightNode
      }), props.onRefresh != null ? /*#__PURE__*/(0,jsx_runtime.jsx)((TouchableOpacity_default()), {
        disabled: refreshing,
        onPress: onRefresh,
        style: refreshing ? StatSummary_styles.refreshingButton : null,
        hitSlop: REFRESH_HIT_SLOP,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((Animated_default()).Image, {
          source: refreshIconSource,
          style: [dynamicSpinStyle, StatSummary_styles.refreshIcon]
        })
      }) : null]
    }), props.descriptionNode != null ? /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
      style: StatSummary_styles.infoRow,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* default */.Z, {
        style: [constants/* TextStyle.T12R */.pn.T12R, constants/* TextStyle.CSecondary */.pn.CSecondary],
        children: props.descriptionNode
      })
    }) : null]
  });
};
var StatSummary_styles = StyleSheet_default().create({
  root: {
    paddingTop: constants/* Grid.dp */.rj.dp(16),
    paddingBottom: constants/* Grid.dp */.rj.dp(8)
  },
  topRow: {
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  refreshingButton: {
    opacity: 0.2
  },
  highlightRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  refreshIcon: {
    width: constants/* Grid.dp */.rj.dp(24),
    height: constants/* Grid.dp */.rj.dp(24)
  },
  infoRow: {
    flexDirection: 'row',
    justifyContent: 'space-between'
  }
});
;// CONCATENATED MODULE: ./src/components/Layout/index.tsx







/***/ }),

/***/ 46807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ Modal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22120);
/* harmony import */ var src_components_Portal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39538);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84099);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28908);
/* harmony import */ var react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79057);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);









var Modal = function Modal(props) {
  var onBackgroundPress = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function () {
    props.onClose();
  }, [props.onClose]);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    if (props.visible) {
      document.body.classList.add('noscroll');
    } else {
      document.body.classList.remove('noscroll');
    }
  }, [props.visible]);
  var widthStyle = props.size == 'extra-thin' ? styles.extraThin : props.size == 'thin' ? styles.thin : styles.normal;
  return props.visible ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(src_components_Portal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      id: "modal-card",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_4___default()), {
        style: styles.background,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_5___default()), {
          onPress: onBackgroundPress,
          style: styles.backdrop
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_4___default()), {
          style: [styles.inner, widthStyle],
          children: props.children
        })]
      })
    })
  }) : null;
};
var styles = react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_6___default().create({
  background: {
    // @ts-ignore: (RNW CSS)
    position: 'fixed',
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: 999
  },
  backdrop: {
    // @ts-ignore: (RNW CSS)
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
  },
  inner: {
    // @ts-ignore: (RNW CSS)
    flex: 'unset',
    // @ts-ignore: (RNW CSS)
    flexGrow: 'unset',
    // @ts-ignore: (RNW CSS)
    boxShadow: '0px 16px 70px rgba(0,0,0,.25)',
    // @ts-ignore: (RNW CSS)
    position: 'relative',
    borderRadius: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dp */ .rj.dp(12),
    top: '50%',
    left: '50%',
    backgroundColor: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .NewColor.White */ .Wq.White,
    transform: [{
      // @ts-ignore: (RNW CSS)
      translateX: '-50%'
    }, {
      // @ts-ignore: (RNW CSS)
      translateY: '-50%'
    }],
    maxHeight: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dp */ .rj.dp(640),
    overflow: 'hidden'
  },
  extraThin: {
    width: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dpFromPx */ .rj.dpFromPx(240)
  },
  thin: {
    width: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dpFromPx */ .rj.dpFromPx(480)
  },
  normal: {
    width: src_constants__WEBPACK_IMPORTED_MODULE_1__/* .Grid.dpFromPx */ .rj.dpFromPx(640)
  }
});

/***/ }),

/***/ 39538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Portal; }
});

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/Portal/usePortal.ts
// From https://www.jayfreestone.com/writing/react-portals-with-hooks/

/**
 * Creates DOM element to be used as React root.
 * @returns {HTMLElement}
 */

function createRootElement(id) {
  var rootContainer = document.createElement('div');
  rootContainer.setAttribute('id', id);
  return rootContainer;
}
/**
 * Appends element as last child of body.
 * @param {HTMLElement} rootElem
 */


function addRootElement(rootElem) {
  if (document.body.lastElementChild != null) {
    document.body.insertBefore(rootElem, document.body.lastElementChild.nextElementSibling);
  }
}
/**
 * Hook to create a React Portal.
 * Automatically handles creating and tearing-down the root elements (no SRR
 * makes this trivial), so there is no need to ensure the parent target already
 * exists.
 * @example
 * const target = usePortal(id, [id]);
 * return createPortal(children, target);
 * @param {String} id The id of the target container, e.g 'modal' or 'spotlight'
 * @returns {HTMLElement} The DOM node to use as the Portal target.
 */


function usePortal(id) {
  var rootElemRef = (0,react.useRef)(null);
  (0,react.useEffect)(function setupElement() {
    // Look for existing target dom element to append to
    var existingParent = document.querySelector("#".concat(id)); // Parent is either a new root or the existing dom element

    var parentElem = existingParent !== null && existingParent !== void 0 ? existingParent : createRootElement(id); // If there is no existing DOM element, add a new one.

    if (!existingParent) {
      addRootElement(parentElem);
    }

    if (rootElemRef.current != null) {
      // Add the detached element to the parent
      parentElem.appendChild(rootElemRef.current);
    }

    return function removeElement() {
      var _rootElemRef$current;

      (_rootElemRef$current = rootElemRef.current) === null || _rootElemRef$current === void 0 ? void 0 : _rootElemRef$current.remove();

      if (!parentElem.childElementCount) {
        parentElem.remove();
      }
    };
  }, [id]);
  /**
   * It's important we evaluate this lazily:
   * - We need first render to contain the DOM element, so it shouldn't happen
   *   in useEffect. We would normally put this in the constructor().
   * - We can't do 'const rootElemRef = useRef(document.createElement('div))',
   *   since this will run every single render (that's a lot).
   * - We want the ref to consistently point to the same DOM element and only
   *   ever run once.
   * @link https://reactjs.org/docs/hooks-faq.html#how-to-create-expensive-objects-lazily
   */

  function getRootElem() {
    if (!rootElemRef.current && __webpack_require__.g['document'] != null) {
      rootElemRef.current = document.createElement('div');
    }

    return rootElemRef.current;
  }

  return getRootElem();
}

/* harmony default export */ var Portal_usePortal = (usePortal);
;// CONCATENATED MODULE: ./src/components/Portal/index.tsx



var Portal = function Portal(props) {
  var target = Portal_usePortal(props.id);
  return target != null ? /*#__PURE__*/(0,react_dom.createPortal)(props.children, target) : null;
};

/* harmony default export */ var components_Portal = (Portal);

/***/ }),

/***/ 31660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Array": function() { return /* reexport */ array; },
  "Format": function() { return /* reexport */ format_namespaceObject; },
  "Math": function() { return /* reexport */ math; },
  "Observe": function() { return /* reexport */ observe; },
  "sleep": function() { return /* reexport */ sleep; }
});

// UNUSED EXPORTS: Enum, Image, Timing

// NAMESPACE OBJECT: ./src/util/format.ts
var format_namespaceObject = {};
__webpack_require__.r(format_namespaceObject);
__webpack_require__.d(format_namespaceObject, {
  "DateLabel": function() { return DateLabel; },
  "DateTime": function() { return DateTime; },
  "DateWithDoWLabel": function() { return DateWithDoWLabel; },
  "DateYearLabel": function() { return DateYearLabel; },
  "DayDateYearLabel": function() { return DayDateYearLabel; },
  "DaysFromNow": function() { return DaysFromNow; },
  "E164National": function() { return E164National; },
  "FromNow": function() { return FromNow; },
  "FromNowWithoutSuffix": function() { return FromNowWithoutSuffix; },
  "IntWithCommas": function() { return IntWithCommas; },
  "IntWithCommasCenti": function() { return IntWithCommasCenti; },
  "IntWithCommasMicro": function() { return IntWithCommasMicro; },
  "IntWithShorthand": function() { return IntWithShorthand; },
  "MoneyCentGranularity": function() { return MoneyCentGranularity; },
  "MoneyCentGranularityCenti": function() { return MoneyCentGranularityCenti; },
  "MoneyCentGranularityMicro": function() { return MoneyCentGranularityMicro; },
  "MoneyDollarGranularity": function() { return MoneyDollarGranularity; },
  "MoneyDollarGranularityCenti": function() { return MoneyDollarGranularityCenti; },
  "MoneyDollarGranularityMicro": function() { return MoneyDollarGranularityMicro; },
  "MoneyInputCentGranularity": function() { return MoneyInputCentGranularity; },
  "Percent": function() { return Percent; },
  "PercentFixedInt": function() { return PercentFixedInt; },
  "ProgressPastDateFromNow": function() { return ProgressPastDateFromNow; },
  "ProgressiveDate": function() { return ProgressiveDate; },
  "ShortFutureFromNow": function() { return ShortFutureFromNow; },
  "ShortPastFromNow": function() { return ShortPastFromNow; },
  "SignedPercentFixedTwoDecimals": function() { return SignedPercentFixedTwoDecimals; },
  "Time": function() { return Time; }
});

// EXTERNAL MODULE: ./src/util/array.ts
var array = __webpack_require__(10997);
// EXTERNAL MODULE: ./node_modules/moment-timezone/index.js
var moment_timezone = __webpack_require__(80008);
var moment_timezone_default = /*#__PURE__*/__webpack_require__.n(moment_timezone);
;// CONCATENATED MODULE: ./src/util/format.ts

var MoneyCentGranularityNumberFormat = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});
var MICRO = 1000000;
var CENTI = 100;
var MoneyCentGranularity = function MoneyCentGranularity(v) {
  return MoneyCentGranularityNumberFormat.format(v);
};
var MoneyCentGranularityCenti = function MoneyCentGranularityCenti(v) {
  return MoneyCentGranularityNumberFormat.format(v / CENTI);
};
var MoneyCentGranularityMicro = function MoneyCentGranularityMicro(v) {
  return MoneyCentGranularityNumberFormat.format(v / MICRO);
};
var MoneyDollarGranularityNumberFormat = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
});
var MoneyDollarGranularity = function MoneyDollarGranularity(v) {
  return MoneyDollarGranularityNumberFormat.format(v);
};
var MoneyDollarGranularityCenti = function MoneyDollarGranularityCenti(v) {
  return MoneyDollarGranularityNumberFormat.format(v / CENTI);
};
var MoneyDollarGranularityMicro = function MoneyDollarGranularityMicro(v) {
  return MoneyDollarGranularityNumberFormat.format(v / MICRO);
};
var MoneyInputCentGranularityNumberFormat = new Intl.NumberFormat('en-US', {
  useGrouping: false,
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});
var MoneyInputCentGranularity = function MoneyInputCentGranularity(v) {
  return MoneyInputCentGranularityNumberFormat.format(v);
};
var Percent = function Percent(v) {
  return "".concat(v, "%");
};
var PercentFixedInt = function PercentFixedInt(v) {
  return "".concat(Math.floor(v), "%");
};
var SignedPercentFixedTwoDecimalsNumberFormat = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});
var SignedPercentFixedTwoDecimals = function SignedPercentFixedTwoDecimals(v) {
  return "".concat(v > 0 ? '+' : '').concat(SignedPercentFixedTwoDecimalsNumberFormat.format(v), "%");
};
var IntWithCommasNumberFormat = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
});
var IntWithShorthand = function IntWithShorthand(v) {
  if (v >= 1000) {
    var clamped = Math.floor(v / 100) / 10;
    return "".concat(clamped, "k");
  } else {
    return IntWithCommasNumberFormat.format(v);
  }
};
var IntWithCommas = function IntWithCommas(v) {
  return IntWithCommasNumberFormat.format(v);
};
var IntWithCommasCenti = function IntWithCommasCenti(v) {
  return IntWithCommasNumberFormat.format(v / CENTI);
};
var IntWithCommasMicro = function IntWithCommasMicro(v) {
  return IntWithCommasNumberFormat.format(v / MICRO);
};
var DaysFromNow = function DaysFromNow(v) {
  var daysLeft = Math.floor((v.valueOf() - Date.now()) / (86400 * 1000));

  if (daysLeft > 0) {
    return "in ".concat(daysLeft, " day").concat(daysLeft === 1 ? '' : 's');
  } else {
    return "".concat(daysLeft, " day").concat(daysLeft === -1 ? '' : 's', " ago");
  }
};
var FromNow = function FromNow(v) {
  return v.fromNow();
};
var FromNowWithoutSuffix = function FromNowWithoutSuffix(v) {
  return v.fromNow(true);
}; // Modified https://stackoverflow.com/a/3177838

var ShortPastFromNow = function ShortPastFromNow(v) {
  var seconds = Math.floor((Date.now() - v.valueOf()) / 1000);
  var interval = seconds / 31536000;

  if (interval > 1) {
    return DateYearLabel(v);
  }

  interval = seconds / 2592000;

  if (interval > 1) {
    return DateLabel(v);
  }

  interval = seconds / 86400;

  if (interval > 1) {
    return Math.floor(interval) + 'd';
  }

  interval = seconds / 3600;

  if (interval > 1) {
    return Math.floor(interval) + 'h';
  }

  interval = seconds / 60;
  return Math.max(Math.floor(interval), 1) + 'm';
}; // Modified https://stackoverflow.com/a/3177838

var ProgressPastDateFromNow = function ProgressPastDateFromNow(v) {
  var seconds = Math.floor((Date.now() - v.valueOf()) / 1000);
  var interval = seconds / 31536000;

  if (interval > 1) {
    return DateYearLabel(v);
  }

  return DateLabel(v);
};
var ShortFutureFromNow = function ShortFutureFromNow(v) {
  // Seconds difference
  var seconds = Math.floor((v.valueOf() - Date.now()) / 1000);
  var interval = seconds / 31536000;

  if (interval > 1) {
    return DateYearLabel(v);
  }

  interval = seconds / 2592000;

  if (interval > 1) {
    return DateLabel(v);
  }

  interval = seconds / 86400;

  if (interval > 1) {
    return Math.floor(interval) + ' day' + (Math.floor(interval) === 1 ? '' : 's');
  }

  interval = seconds / 3600;

  if (interval > 1) {
    return Math.floor(interval) + ' hour' + (Math.floor(interval) === 1 ? '' : 's');
  }

  interval = seconds / 60;
  return Math.max(Math.floor(interval), 1) + ' minute' + (Math.floor(interval) === 1 ? '' : 's');
};
var ProgressiveDate = function ProgressiveDate(v) {
  var m = moment_timezone_default()();
  var daysDiff = m.clone().diff(v, 'days');

  if (daysDiff < 1) {
    return 'Today';
  } else if (daysDiff < 2) {
    return 'Yesterday';
  } else if (daysDiff < 7) {
    return v.format('dddd');
  } else if (v.get('year') === m.clone().get('year')) {
    return v.format('ddd, MMM D');
  } else {
    return v.format('ddd, MMM D, YYYY');
  }
};
var DateWithDoWLabel = function DateWithDoWLabel(v) {
  return v.format('ddd, MMM D');
};
var DayDateYearLabel = function DayDateYearLabel(v) {
  return v.format('dddd MMM DD, YYYY');
};
var DateYearLabel = function DateYearLabel(v) {
  return v.format('MMM DD, YYYY');
};
var DateLabel = function DateLabel(v) {
  return v.format('MMM DD');
};
var DateTime = function DateTime(v) {
  return v.format('MMM DD h:mm A');
};
var Time = function Time(v) {
  return v.format('h:mm A');
}; // Note (albert): This suffers from the same delimiter issue as web :)

var E164National = function E164National(v) {
  var digits = v.replace(/\+1/g, '') // TODO (albert) This is approximate, only works for US and Canada
  .replace(/\D+/g, '');

  if (digits.length === 0) {
    return '';
  } else if (digits.length < 4) {
    return "(".concat(digits.slice(0, 3));
  } else if (digits.length < 7) {
    return "(".concat(digits.slice(0, 3), ") ").concat(digits.slice(3, 6));
  } else {
    return "(".concat(digits.slice(0, 3), ") ").concat(digits.slice(3, 6), "-").concat(digits.slice(6, 10));
  }
};
// EXTERNAL MODULE: ./src/util/math.ts
var math = __webpack_require__(45997);
// EXTERNAL MODULE: ./src/util/observe/index.ts + 2 modules
var observe = __webpack_require__(71182);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
;// CONCATENATED MODULE: ./src/util/timing.ts


var log = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(logNs, f) {
    var now, res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            now = Date.now();
            _context.next = 3;
            return f();

          case 3:
            res = _context.sent;
            console.debug("[".concat(logNs, "] start_at=").concat(now, " d=").concat(Date.now() - now));
            return _context.abrupt("return", res);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function log(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}()));
// EXTERNAL MODULE: ./src/util/page.ts
var page = __webpack_require__(83279);
;// CONCATENATED MODULE: ./src/util/sleep.ts
var sleep = function sleep(ms) {
  return new Promise(function (resolve) {
    setTimeout(function () {
      resolve();
    }, ms);
  });
};
;// CONCATENATED MODULE: ./src/util/index.ts

















/***/ }),

/***/ 45997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "max": function() { return /* binding */ max; },
/* harmony export */   "sum": function() { return /* binding */ sum; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27812);

var sum = function sum(items) {
  var sum = 0;

  for (var i = 0; i < items.length; i++) {
    sum += items[i];
  }

  return sum;
};
var max = function max(items) {
  return items.length > 0 ? Math.max.apply(Math, (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(items)) : null;
};

/***/ }),

/***/ 83279:
/***/ (function() {



/***/ })

}]);